export default "__VITE_ASSET__BEmsusZ6__"